var _rect, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowprocess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 165,
    viewBox: "0 0 249 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 3,
    transform: "matrix(-1 0 0 1 131 82)",
    fill: "url(#paint0_linear_26_2818)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 247 151)",
    fill: "#FF0000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 248.5 0)",
    fill: "#03A400"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 135 77)",
    fill: "#FFB802"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 14.5 77)",
    fill: "#A6A4A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195 38V70.8088C194.859 75.2059 191.796 84 180.576 84C169.121 84 151.091 83.999 132 83.9987",
    stroke: "#FFB802",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195 54V21.1912C195.141 16.7941 198.204 8 209.424 8C220.879 8 216.909 8.00102 236 8.00131",
    stroke: "url(#paint1_linear_26_2818)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195 130V97.1912C194.859 92.7941 191.796 84 180.576 84C169.121 84 151.091 84.001 132 84.0013",
    stroke: "#FFB802",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195 114V146.809C195.141 151.206 198.204 160 209.424 160C220.879 160 223.909 159.999 243 159.999",
    stroke: "url(#paint2_linear_26_2818)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_2818",
    x1: 7.78954e-8,
    y1: 2.00002,
    x2: 117.57,
    y2: 1.60785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB802"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_2818",
    x1: 236,
    y1: 8,
    x2: 195,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_2818",
    x1: 237.5,
    y1: 160,
    x2: 195,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB802"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowprocess);
export default __webpack_public_path__ + "static/media/flowprocess.13f1394e6884e9af6d28460c39eb36d8.svg";
export { ForwardRef as ReactComponent };